import { memo } from 'react';

import { useBreakpointsContext } from '@air/provider-media-query';
import { cn } from '@air/utils-tailwind';

import { NoAssetsAddedDesktopAsset } from '~/components/ContributableNullState/NoAssetsAddedDesktopAsset';
import { NoAssetsAddedMobileAsset } from '~/components/ContributableNullState/NoAssetsAddedMobileAsset';
import { NullState, type NullStateProps } from '~/components/NullState';

export type ContributableNullStateProps = {
  description?: string;
  hasBackground?: boolean;
  'data-testid'?: string;
} & Omit<NullStateProps, 'image' | 'description'>;

const DEFAULT_DESCRIPTION = 'Upload from your computer via drag-and-drop, or click the button below';

export const ContributableNullState = memo(
  ({
    title,
    cta,
    description = DEFAULT_DESCRIPTION,
    hasBackground = true,
    'data-testid': testId,
  }: ContributableNullStateProps) => {
    const { isAboveMediumScreen } = useBreakpointsContext();
    return (
      <NullState
        testId={testId}
        className={cn(!hasBackground && 'min-h-[60vh] justify-center bg-none')}
        image={
          hasBackground && (
            <div>
              {isAboveMediumScreen ? (
                <NoAssetsAddedDesktopAsset className="mx-auto -mb-4 w-full" />
              ) : (
                <NoAssetsAddedMobileAsset className="mx-auto" />
              )}
            </div>
          )
        }
        title={title}
        description={description}
        cta={cta}
      />
    );
  },
);

ContributableNullState.displayName = 'ContributableNullState';
